define.alias("ember-math-helpers/helpers/lcm", "media/helpers/lcm");